import { styled } from "@mui/material/styles";
import { BSPH4 } from "../BSPH4";
import { BigSpringMarkV2Icon } from "../../../../icons";

export const BigSpringLogo = styled(BigSpringMarkV2Icon)`
  width: 32px;
  height: 36px;
`;

export const StyledLogoText = styled(BSPH4)`
  color: #313131;
  font-size: 2rem;
  font-weight: 500;
`;
